import { isEmpty } from "lodash";
import { Inventory, InventoryItem } from "./inventory";
import { formatAmountWithoutDots } from "./common";
import { Transaction } from "./transaction";
import { StoreToConsumer } from "./customer";

export interface ChildInvoice {
  id: string;
  amount: string | number;
  status: string;
}

export interface ViewInvoice {
  invoiceDetails: InvoiceDetails;
  consumerDetails: ConsumerDetails;
  merchantDetails: MerchantDetails;
  txDetails: Transaction;
  childInvoices?: ChildInvoice[];
}
export interface InvoiceDetails {
  id: string;
  consumerId: string;
  jobId?: null;
  amount: number;
  status: string;
  invoiceNumber: string;
  refCode?: string | null;
  transactionId: string;
  expiresOn: string;
  paymentLink?: string | null;
  invoiceType: string;
  items: (ItemsEntity) | null;
  createdAt: Date;
  updatedAt: Date | string;
  ConsumerId: string;
}
export interface ItemsEntity {
  shippingFee: string
  itemsList: LineItemData[];
}
export interface LineItemData {
  _id: string;
  code?: number
  productName: string;
  productCode: string;
  itemDescription: string;
  itemCommodityCode: string;
  unitCost: string;
  unitMeasure: string;
  unitMeasureLabel: string;
  stateTaxRate?: number;
  localTaxRate?: number;
  totalTax?: number | string
  taxRate: string;
  discountRate: number;
  discountAmount: any;
  createdBy: string;
  merchantEmail: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  quantity: string;
  totalAmount: string;
  description: string;
  individualPrice: number
  totalBaseAmountWithoutDiscount: number;
}
export interface ConsumerDetails {
  id: string;
  merchantId: string;
  email: string;
  phone: string;
  lastName?: string | null;
  firstName?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
}
export interface MerchantDetails {
  id: string;
  firstName: string;
  lastName: string;
  merchantLogo: string;
  email: string;
  phoneNumber: string;
  city: string;
  state: string;
  dba?: String;
}

export interface Invoice {
  id: string;
  invoiceNumber: string;
  consumerId: string;
  amount: number;
  status: string;
  refCode: string;
  transactionId?: null;
  expiresOn: string;
  createdAt: string;
  updatedAt: string;
  paymentLink: string;
  items: InvoiceItems;
  invoiceType: string;
  invoiceFilePath: string;
  tpn;
  consumer_to_invoice: ConsumerToInvoice;
  job_to_invoice: JobToInvoice;
  phone:number;
  email:string;
  expiryTime:string
}
export interface InvoiceItems {
  shippingFee: string;
  shipToZIP: string;
  itemsList?: (ItemsListEntity)[] | null;
}
export interface ItemsListEntity {
  item: InventoryItem;
  itemCount: string;
  itemPrice: number | string;
  totalAmount: number;
  discount?: number | null;
  description: string;
  discountType: string;
  discountAmount?: number | null;
  totalTaxAmount?: number | null;
  stateTaxAmount?: number | null;
  localTaxAmount?: number | null;
  trackingId?: null;
}

export interface ConsumerToInvoice {
  id: string;
  consumerId: string;
  email: string;
  phone: string;
  store_to_consumer: StoreToConsumer
}
export interface JobToInvoice {
  id?: null;
  name?: null;
}

export const getL2L3LineItemDetails = (lineItemsArray) => {
  const lineItemData = []
  let lineItemIndex = 1
  for (let i = 0; i < lineItemsArray.length; i++) {
    const item = {
      lineItemData: getEachLineItem(lineItemsArray[i]),
      details: `LI${lineItemIndex}`,
    }

    if (item.lineItemData) {
      lineItemIndex++
      lineItemData.push(item)
    }
  }
  return lineItemData
}

export const getEachLineItem = (eachItem) => {

  // if (!isEachLineItemValid(eachItem)) {
  //   return null
  // }

  let lineItem = eachItem.item as LineItemData
  lineItem.unitCost = eachItem.item.unitCost
  lineItem.quantity = eachItem.itemCount
  lineItem.totalAmount = eachItem.totalAmount
  if (isEmpty(eachItem.description)) {
    lineItem.description = 'NA';
  } else {
    lineItem.description = eachItem.description;
  }
  // discount amount and percentage is handled in discount property  
  lineItem.discountAmount = eachItem.discountAmount
  lineItem.totalTax = eachItem.taxAmount

  return lineItem
}

export const isEachLineItemValid = (eachItem) => {
  if (eachItem.item && eachItem.itemCount && eachItem.itemPrice && eachItem.totalAmount) {
    return true
  }
  else {
    return false
  }
}

export const handleLineItemEmptyValues = (lineItem) => {
  lineItem.totalAmount && (lineItem.totalAmount = (lineItem.totalAmount * 100).toString())
  lineItem.unitCost && (lineItem.unitCost = (lineItem.unitCost * 100).toString())
  lineItem.taxRate && (lineItem.taxRate = (lineItem.stateTaxRate).toString() || "0")
  lineItem.quantity && (lineItem.quantity = lineItem.quantity.toString())
  if (!lineItem.taxRate) {
    lineItem.taxRate = "0"
  }

  if (!lineItem.discountRate) {
    lineItem.discountRate = "0"
  }

  if (!lineItem.discountAmount) {
    lineItem.discountAmount = "0"
  }
  else {

    lineItem.discountAmount = (lineItem.discountAmount * 100).toString()
  }
  return lineItem


}

export const getLineItemDetails = (lineitems) => {

  let totalTaxAmount = 0, totalAmount = 0, totalDiscount = 0, totalBaseAmount = 0
  const lineItemsArray = lineitems.map((item, index) => {
    const each = item.lineItemData
    let totalTax = 0
    let eachTotalPrice = (each.quantity) * +(each.unitCost)
    let totalBaseAmountWithoutDiscount = eachTotalPrice
    totalBaseAmount += eachTotalPrice
    let disAmo = 0

    if (each.discountRate && each.discountRate != '0') {
      disAmo = each.discountAmount
    }
    else if (each.discountAmount) {
      disAmo = parseInt(each.discountAmount)
    }
    eachTotalPrice -= disAmo
    totalDiscount += disAmo

    // calculating discount
    // should be applied before tax only.

    each.totalTax = formatAmountWithoutDots(each.totalTax)

    totalTaxAmount += +(each.totalTax)
    each.individualPrice = eachTotalPrice

    each.totalBaseAmountWithoutDiscount = totalBaseAmountWithoutDiscount
    totalAmount += +each.totalAmount
    // if (each.discountRate) {
    //   each.discountAmount = (each.discountRate * parseInt(each.unitCost)).toFixed(2)
    // }
    each.code = index + 1
    return each
  })

  return { lineItemsArray, totalAmount, totalTax: totalTaxAmount, totalDiscount, totalBaseAmount }

}